/**
 * @example
 * > capitalize('meow') //=> 'Meow'
 * > capitalize('test string') //=> 'Test string'
 */
export const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1)


export const titleCase = capitalize